import React, { useState } from 'react'
import VideoModal from '../../HomePages/home-one/section/videoModal';
import { Link } from 'react-router-dom';
import ImageWithBasePath from '../../../core/common/imageWithBasePath';
import { all_routes } from '../../router/all_routes';
// import Whatsnew from './whatsnew';
// import Whatsnew2 from './whatsnew2';
import CountUp from 'react-countup'
import Accordin from './Accordin2'
// import Benefits from './Benefits'

interface BannerProps {
    apiValues: any;
}



const IndividualUniversity: React.FC<BannerProps> = ({ apiValues }) => {

    const bgImageUrl = "/assets/img/backgroundpalanicard/cardbackground.jpg"; // Replace with actual image URL

    const [showModal, setShowModal] = useState(false);
    const videoUrl = 'https://www.youtube.com/embed/1trvO6dqQUI';

    const handleOpenModal = () => setShowModal(true);
    const handleCloseModal = () => setShowModal(false);

    const route = all_routes;

    return (
        <>
            <>








                <div className="container flex flex-col items-start lg:flex-row gap-4 w-full mt-3 p-2">

                    <div className="w-full lg:w-[75%]">
                        <Accordin apiValues={apiValues} />
                    </div>


                    {/* <div className="w-full lg:w-[25%] flex flex-col rounded-md border border-gray-300 p-5 space-y-10">
                       
                        <div className="subsribe-section  bg-cover bg-center p-3 "
                            style={{
                                backgroundImage: `url(${bgImageUrl})`,
                            }}>

                            <ImageWithBasePath
                                src="assets/img/individual/image2.png"
                                alt="img"
                                className="w-full h-auto max-w-[300px] mx-auto" 
                            />

                            <div className="flex justify-center">
                                <ImageWithBasePath
                                    src="assets/img/individual/logo.png"
                                    alt="img"
                                    className="w-64 h-auto sm:w-36 md:w-48" 
                                />
                            </div>

                        </div>




                       



                    </div> */}

                    <div
                        className="w-full lg:w-[25%]  flex flex-col rounded-md border border-gray-300 p-5 space-y-10 bg-cover bg-center min-h-[400px]"
                        style={{ backgroundImage: `url(${bgImageUrl})` }}
                    >
                        {/* <ImageWithBasePath
                            src="assets/img/individual/image2.png"
                            alt="img"
                            className="w-full h-auto max-w-[300px] mx-auto"
                        /> */}

                        <div className="flex justify-center">
                            <ImageWithBasePath
                                source={apiValues?.collapseRightSideImage?.imageUrl}
                                alt="imgjj"
                                className="w-64 h-auto sm:w-36 md:w-48"
                            />
                        </div>
                    </div>


                </div>


                {/* <Whatsnew />
                <Whatsnew2 /> */}

                {/* <Benefits /> */}




            </>

        </>
    )
}

export default IndividualUniversity
